<template>
    <div>
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                v-show="innerShouldShow"
                :vid="'validate-' + fieldAssignmentId"
            >
                <v-row class="mb-2" dense>
                    <v-col cols="12">
                        <label
                            v-for="(option, idx) in vProps.items"
                            :key="`redemption-option-${idx}`"
                            class="d-block d-md-inline-block redemption-selection"
                        >
                            <input
                                v-model="innerValue"
                                class="redemption-selection__radio"
                                :value="option[valAttr]"
                                type="radio"
                                name="redemption"
                            />
                            <v-card
                                v-ripple
                                :flat="innerValue !== option[valAttr]"
                                :elevation="2"
                                :class="[
                                    innerValue === option[valAttr]
                                        ? 'selected-border'
                                        : 'grey lighten-4',
                                    'cursor-pointer'
                                ]"
                                width="140"
                            >
                                <v-card-text
                                    class="text-center text-uppercase font-weight-bold"
                                >
                                    <div class="text-center full-width" v-if="option.values && option.values.icon">
                                        <v-icon class="text-primary" style="font-size: 85px">{{option.values.icon}}</v-icon>
                                    </div>
                                    <template v-else>
                                        <v-img
                                            :src="
                                                '/media/photos/portal/' +
                                                    option.icon
                                            "
                                            max-height="78"
                                            max-width="78"
                                            class="mb-2 mx-auto"
                                        />
                                    </template>
                                    {{ option.name }}
                                </v-card-text>
                            </v-card>
                        </label>
                    </v-col>
                </v-row>
                <p
                    v-for="(error, idx) in errors"
                    :key="`redemption-error-${idx}`"
                    class="error--text"
                >
                    {{ error }}
                </p>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import TypeReview from './TypeReview';
import formMixin from '../formMixin';
export default {
    name: 'TypeSelect',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                items: this.value_options || [],
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        },
        valAttr() {
            return (
                (this.componentProps && this.componentProps.valAttr) || 'name'
            );
        }
    }
};
</script>
<style lang="scss" scoped>
@import 'resources/sass/custom/portal/variables/main.scss';
.redemption-selection {
    // width: 100%;
    margin: 5px;

    &__radio {
        position: absolute;
        opacity: 0;
    }
}

.cursor-pointer {
    cursor: pointer;
}

.selected-border {
    border: 2px solid $bw-green !important;
    background-color: #f5f5f5 !important;
}
</style>
